import React from 'react';
import {useStyles} from "./TopupSalePrices.style";
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import { useCommonContext } from '../../../../contexts/CommonContext';
import { useI18nContext } from '../../../../contexts/I18nContext';
import TopupSalePriceStore from './TopupSalePriceStore';
import { Observer } from 'mobx-react-lite';
import TopupSalePriceRow from './TopupSalePricesRow/TopupSalePriceRow';
import MessageCard from '../../../../ui_components/MessageCard/MessageCard';
import TopupSalePricesProperties from './TopupSalePricesProperties';
import CopyServicePricesButton from '../../../../shared_components/Buttons/CopyServicePricesButton/CopyServicePricesButton';
import SalePriceItemType from '../../../../entities/SalePriceItemType';
import ButtonSize from '../../../../ui_components/Button/ButtonSize';
import ButtonType from '../../../../ui_components/Button/ButtonType';


const TopupSalePrices: React.FC<TopupSalePricesProperties> = ({
    salePrice,
    onUpdate = () => {
    },
}) => {
    const commonStore = useCommonContext();
    const i18n = useI18nContext();
    const store = new TopupSalePriceStore(commonStore);
    const classes = useStyles();

    store.getTopupProducts();

    return (
        <Observer>
            {() => (
                <div className={classes.topup_sale_prices_container}>
                    <div className={classes.new_button_container}>
                        <CopyServicePricesButton
                            size={ButtonSize.SMALL}
                            onSave={onUpdate}
                            showText
                            sourceSalePriceId={salePrice?.id ?? ''}
                            serviceName={SalePriceItemType.TOPUP}
                            type={ButtonType.SECONDARY}
                        />
                    </div>
                    {!store.isEmpty &&
                    <div className={classes.topup_sale_prices_table}>
                        <div className={classes.elements_container}>
                            {store.topupProducts.map((topupProduct, i) => (
                                <TopupSalePriceRow
                                    onUpdate={onUpdate}
                                    topupProduct={topupProduct}
                                    salePrice={salePrice}
                                    key={i}
                                />
                            ))}
                        </div>
                    </div>}
                    {store.isEmpty &&
                    <MessageCard icon={CurrencyExchangeIcon} title={i18n.translate("NO_MONEY_SERVICE_FEE_TITLE")}
                                 subtitle={i18n.translate("NO_MONEY_SERVICE_FEE_SUBTITLE")}/>}
                </div>
            )}
        </Observer>
    )
}

export default TopupSalePrices;
